
const state = {
  paymentsToggleHeaders: [
    { id: 'payment_date', display: true },
    { id: 'balance', display: true }
  ],
  quickstartDrawer: false,
  testMode: false
}

const actions = {
  TOGGLE_HEADERS: ({ commit }, { resource, columnId }) => {
    commit('TOGGLE_HEADERS', { resource, columnId })
  }
}

const mutations = {
  SET_TEST_MODE (state, value) {
    state.testMode = value
  },
  TOGGLE_QUICKSTART_DRAWER (state, value) {
    state.quickstartDrawer = typeof value === 'boolean' ? value : !state.quickstartDrawer
  },
  TOGGLE_HEADERS: (state, { resource, columnId }) => {
    const headers = state[`${resource}ToggleHeaders`]

    state[`${resource}ToggleHeaders`] = headers.map(e => {
      if (e.id === columnId) {
        return {...e, display: !e.display}
      }
      return e
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
